import { render, staticRenderFns } from "./smallOrderIndex.vue?vue&type=template&id=0b96b1be"
import script from "./smallOrderIndex.vue?vue&type=script&lang=js"
export * from "./smallOrderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports